"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const createJourneyComponent_1 = require("../../lib/createJourneyComponent");
const helpers_1 = require("../../lib/helpers");
const Input_1 = __importDefault(require("./Base/Input"));
exports.Radio = createJourneyComponent_1.createJourneyComponent('j-radio', (props) => {
    const primitiveProps = helpers_1.without(helpers_1.usePrimitiveProps(props), ['children', 'id', 'name', 'value']);
    return (react_1.default.createElement("div", Object.assign({}, primitiveProps, { className: classnames_1.default(props.className, { checked: props.checked }) }),
        react_1.default.createElement(Input_1.default, { name: props.name, value: props.value, onChange: props.onChange, onClick: props.onClick, checked: props.checked, type: "radio" }),
        props.checked && react_1.default.createElement("div", { className: "j-radio-mark" })));
});
